export default __webpack_public_path__ + "static/media/sample.196bac88.jpg";